import React = require('react');
import ReactDOM = require('react-dom');
import { SharedCompUserList, IUserItem } from './SharedCompUserList';
import Ajax from '../../lib/Ajax';
import { IEventForList } from '../../../interfaces/models/IEvent';
import { Tools } from '../../lib/Tools';

interface IUpcomingEventProps {

}

interface IUpcomingEventState {
    items:Array<IUserItem>
}

class UpcomingEvent extends React.Component<IUpcomingEventProps, IUpcomingEventState>{

      constructor(props:IUpcomingEventProps){
        super(props);
        // set initial state
        this.state = this.getInitState();
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/event/getUpcomingEvents', 'POST', {}, (data:Array<IEventForList>) => {
            var items:Array<IUserItem> = [];
            for (var key in data) {
                var item = data[key];
                items.push({
                    id: item.id,
                    name: item.name + ' >>',
                    img: item.headerImage,
                    affinity: Tools.dateTimeDistanceFormatter(item),
                    address: item.address,
                    link: '/esemenyek/' + item.id,
                    content: item.content
                });
            }

            this.setState({
                items : items
            });
        });
    }


    protected getInitState():any{
        return {
            items: []
        };
    }

    render() {
        return (
            <SharedCompUserList editMode={false} title="Közelgő események" emptyText="Nincsenek közelgő események!" userList={ this.state.items} classNames="upcoming_event" template="upcoming_event" />
        );
    }
}
export class InitUpcomingEvent {
    constructor() {
        var div: HTMLDivElement = document.getElementById('my_upcoming_event_comp') as HTMLDivElement;
        if (div !== null) {
           ReactDOM.render(<UpcomingEvent  />, div);
        }
    }
}





// WEBPACK FOOTER //
// ./components/event/UpcomingEvent.tsx